var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FFDBDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.6667V20M20 23.3333H20.0083M27.5 20C27.5 20.9849 27.306 21.9602 26.9291 22.8701C26.5522 23.7801 25.9997 24.6069 25.3033 25.3033C24.6069 25.9997 23.7801 26.5522 22.8701 26.9291C21.9602 27.306 20.9849 27.5 20 27.5C19.0151 27.5 18.0398 27.306 17.1299 26.9291C16.2199 26.5522 15.3931 25.9997 14.6967 25.3033C14.0003 24.6069 13.4478 23.7801 13.0709 22.8701C12.694 21.9602 12.5 20.9849 12.5 20C12.5 18.0109 13.2902 16.1032 14.6967 14.6967C16.1032 13.2902 18.0109 12.5 20 12.5C21.9891 12.5 23.8968 13.2902 25.3033 14.6967C26.7098 16.1032 27.5 18.0109 27.5 20Z",
    stroke: "#F32D2D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/images/error_icon.0a221bad844ec779cac0f8cfca6566d5.svg";
export { ForwardRef as ReactComponent };